//#region Styles
import { Column } from "components/styles";
//#endregion
//#region Components
import LocationPlaceStep1 from "./components/LocationPlaceStep1/LocationPlaceStep1";
import LocationPlaceStep2 from "./components/LocationPlaceStep2/LocationPlaceStep2";
import LocationPlaceStep2InCampus from "./components/LocationPlaceStep2/LocationPlaceStep2InCampus";
//#endregion

const PlaceControls = ({
    as, form, errors,
    data: {
        campusEnvironments,
        fn: {
            getAllCampusForLocationSearch
        }
    },
    onlyInCampus,
    changeFields: {
        changePlaceCampus,
        changePlaceCampusOnlyInCampus,
        changePlaceEnvironment 
    }
}) => {
    return (
        <Column gap="32px" marginTop="20px">
            <LocationPlaceStep1
                campusWidth="340px"
                campus={form.campus}
                error={errors.place.campus}
                allCampus={getAllCampusForLocationSearch()}
                changeCampus={onlyInCampus 
                ? changePlaceCampusOnlyInCampus 
                : changePlaceCampus}
                as={as}/>
            {onlyInCampus 
            ? <LocationPlaceStep2InCampus 
                errors={errors.place.environment}
                form={form.environment}
                changeField={changePlaceEnvironment}
                as={as}/>
            : <LocationPlaceStep2 
                campusEnvironments={campusEnvironments}
                errors={errors.place.environment}
                campusId={form.campus.id}
                form={form.environment}
                changeField={changePlaceEnvironment}
                as={as}/>}
        </Column> 
    );
}

export default PlaceControls;